<template>
	<div style="width: 100%">
			Listado de dominios... pendient...
	</div>
</template>

<script>

export default {
  name: 'dominios-vista',

  data: () => ({
		//
	}),

	components: {
		//Sitio
	},

	watch: {
		//
	},

	mounted: function() {
		//
	},

	methods: {
		//
	}
};


</script>